import { UserStatus } from 'src/api';

export enum FormFields {
  userStatus = 'status',
}

export type FormValues = {
  [FormFields.userStatus]: UserStatus;
};
